<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="`conditionsRequirements.${deliveryTypesField}`"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeDeliveryTypesField] ? 'Exclude' : 'Include')} Delivery Types`"
      value-type="Array"
      :options="$mh.asOptions(DELIVERY_TYPE_OPTIONS.ALL)"
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one delivery type'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeDeliveryTypesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { DELIVERY_TYPE_OPTIONS } from 'src/models/delivery-type/DeliveryType'
import { CONDITIONS_REQUIREMENTS } from 'src/models/tip/TipShareRule'

export default {
  name: 'DeliveryTypesConditionForm',
  configuration: ['deliveryTypes'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    deliveryTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.DELIVERY_TYPES
    },
    excludeDeliveryTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_DELIVERY_TYPES
    }
  },
  created () {
    _.extend(this, { DELIVERY_TYPE_OPTIONS })
  }
}

</script>
